import styled from 'styled-components';

export const MobileFilterButtonWrapper = styled.div`
  padding: 0 16px;
`;

export const MobileFiltersButton = styled.div<{ isDisabled?: boolean }>`
  padding: 10px 50px 10px 16px;
  font-size: 16px;
  background: #ffffff;
  border: 1px solid #d2d5da;
  border-radius: 3px;
  position: relative;
  width: 100%;
  opacity: ${(props) => (props.isDisabled ? '0.6' : '1')};
  pointer-events: ${(props) => (props.isDisabled ? 'none' : 'auto')};
`;

export const FilterButtonIcon = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 14px;
`;

export const ButtonWrapper = styled.div`
  padding: 12px 8px;
  background: #ffffff;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 9;
  box-shadow: 0 -0.1em 0.5em 0 rgba(0, 0, 0, 0.3);
  button {
    width: 100%;
    display: block;
    height: 46px;
    cursor: pointer;
    outline: none;
    line-height: 46px;
    font-size: 18px;
    font-weight: bold;
    background: #2980b9;
    color: #ffffff;
    border: none;
    border-radius: 3px;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }
`;
